import { render, staticRenderFns } from "./apps-menu.vue?vue&type=template&id=58b2a074"
import script from "./apps-menu.vue?vue&type=script&lang=js"
export * from "./apps-menu.vue?vue&type=script&lang=js"
import style0 from "./apps-menu.vue?vue&type=style&index=0&id=58b2a074&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports